export const getLoadedImageUrl = (image?: HTMLImageElement | null): string | null =>
  image?.complete && image.naturalWidth > 0 ? image.currentSrc || image.src || null : null;

export const getLoadedImageUrlFromElement = (element: Element | null | undefined, expectedSrc: string | null | undefined): string | null => {
  if (!expectedSrc) return null;
  const image = element?.querySelector<HTMLImageElement>('img');
  return image?.getAttribute('src') === expectedSrc ? getLoadedImageUrl(image) : null;
};

export const getLoadedImageUrlFromEvent = (event: Event | undefined, expectedSrc: string | null | undefined): string | null => {
  if (typeof Element === 'undefined' || !(event?.currentTarget instanceof Element)) return null;
  return getLoadedImageUrlFromElement(event.currentTarget, expectedSrc);
};
